import { TriStateType } from '@zurich/common/types';
const getSelectedSelectableUnitByName = (name, segment) => segment?.selectableUnits?.find((value) => 
//since the tested data had different results, e.g. once _BASIC and once _Basic as name
//we put the string to lowercase to account for such data deviation
value.name?.toLowerCase() === name?.toLowerCase() &&
    TriStateType.getValue(value.selected ?? null));
export const selectedUnitsUtils = {
    getSelectedSelectableUnitByName,
};
